import { buildGroupTableBindings } from '@/components/group-tables/build-group-table-bindings';
import type { TableProps } from '@/ui/Table';

type GroupTableControllerCoreTableArgs<TData> = {
    columns: TableProps<TData>['columns'];
    data: TData[];
    rowKey?: TableProps<TData>['rowKey'];
    tableId?: TableProps<TData>['tableId'];
    tableScope?: TableProps<TData>['tableScope'];
    onSortChanged: NonNullable<TableProps<TData>['onSortChanged']>;
    currentSort: NonNullable<TableProps<TData>['currentSort']>;
    pickedData: string[];
    onAllPicked: () => Promise<void>;
    onHeaderCheckboxChange: NonNullable<TableProps<TData>['onHeaderCheckboxChange']>;
    onCheckboxChange: NonNullable<TableProps<TData>['onCheckboxChange']>;
    isHeaderChecked: boolean;
    checkboxData: NonNullable<TableProps<TData>['checkboxData']>;
    headerSecondaryRow: TableProps<TData>['headerSecondaryRow'];
    onRowClick: NonNullable<TableProps<TData>['onRowClick']>;
};

type BuildGroupTableControllerCoreArgs<
    TData,
    TTableBindings,
    TAnalysisBindings extends object,
    TGroupEditorBindings extends object,
    TResult,
> = {
    table: GroupTableControllerCoreTableArgs<TData>;
    analysis: TAnalysisBindings;
    groupEditor: TGroupEditorBindings;
    buildControllerBindings: (args: {
        table: TTableBindings;
        analysis: TAnalysisBindings;
        groupEditor: TGroupEditorBindings;
    }) => TResult;
};

export const buildGroupTableControllerCore = <
    TData,
    TTableBindings,
    TAnalysisBindings extends object,
    TGroupEditorBindings extends object,
    TResult,
>({
    table,
    analysis,
    groupEditor,
    buildControllerBindings,
}: BuildGroupTableControllerCoreArgs<TData, TTableBindings, TAnalysisBindings, TGroupEditorBindings, TResult>) => {
    const tableBindings = buildGroupTableBindings<TData>(table) as TTableBindings;

    return buildControllerBindings({
        table: tableBindings,
        analysis,
        groupEditor,
    });
};
